<template>
  <div class="uid-intro">
    <div class="popup-shadow" @click="hidePopup"></div>
    <div class="popup-container">
      <a href="javascript:void(0);" class="popup-close" @click="hidePopup"></a>
      <iframe :src="guidePopLink" title="" class="otp-iframe" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import globalConfig from '../../../utiles/globalConfig';
const mainHost = globalConfig.getMainHost();
export default {
  name: 'UidTokenGuidePopup',
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      lang: state => state.lang
    }),
    guidePopLink() {
      return `//auto-page.octlib.com/otp_guide/?gameId=${this.gameId}&language=${this.lang}&host=${mainHost}`;
    }
  },
  methods: {
    hidePopup() {
      this.$emit('hidePopup');
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';
.otp-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.uid-intro {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
}
.popup-shadow {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.popup-container {
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 50%;
  box-sizing: border-box;
  padding: 0 44px 76px;
  width: 90%;
  height: 90%;
  background-size: 100% 100%;
  color: var(--login-uidtoken-guide-popup-tip);
  transform: translate(-50%, -50%);
  // @psetbg ('coupon-popup-bg.png', false, false);
  background-color: #f3f3f3;
}
.popup-close {
  position: absolute;
  cursor: pointer;
  right: 32px;
  top: 27px;
  background: url($commonImg + 'close.png') no-repeat;
  width: 28px;
  height: 28px;
}

@media screen and (orientation: landscape) {
  .popup-container {
    width: 620px;
  }
}
</style>
